<template>
  <g>
    <g>
      <path d="M10.9999,2.9999c2.7609,0,5.1526,1.8724,5.8163,4.5533l0.182,0.7352l0.757,0.024
        c1.8195,0.0577,3.2448,1.5237,3.2448,3.3376c0,1.8472-1.5028,3.35-3.35,3.35h-12.4c-1.2406,0-2.25-1.0094-2.25-2.2501
        c0-0.921,0.5547-1.7391,1.4131-2.0842l0.6992-0.2811L5.0347,9.6351C5.0112,9.4092,4.9999,9.2015,4.9999,9
        C4.9999,5.6916,7.6915,2.9999,10.9999,2.9999 M10.9999,1.9999c-3.866,0-7,3.1331-7,7.0001c0,0.2501,0.015,0.4961,0.04,0.738
        c-1.194,0.48-2.04,1.6451-2.04,3.012c0,1.794,1.4551,3.2501,3.25,3.2501h12.4c2.403,0,4.35-1.9481,4.35-4.35
        c0-2.3561-1.875-4.263-4.213-4.3372C17.0319,4.263,14.2839,1.9999,10.9999,1.9999L10.9999,1.9999z"/>
    </g>
    <path d="M13.8164,20.603L13,20.1316l0.8164-0.4714c0.2393-0.1382,0.3213-0.4438,0.1826-0.6831
      c-0.1377-0.2407-0.4443-0.3213-0.6826-0.1831L12.5,19.2654v-0.9431c0-0.2764-0.2236-0.5-0.5-0.5s-0.5,0.2236-0.5,0.5v0.9431
      l-0.8164-0.4714c-0.2383-0.1367-0.5449-0.0566-0.6826,0.1831c-0.1387,0.2393-0.0566,0.5449,0.1826,0.6831L11,20.1316l-0.8164,0.4714
      c-0.2393,0.1382-0.3213,0.4438-0.1826,0.6831c0.0918,0.1606,0.2607,0.25,0.4326,0.25c0.085,0,0.1709-0.0215,0.25-0.0669
      L11.5,20.9978v0.9431c0,0.2764,0.2236,0.5,0.5,0.5s0.5-0.2236,0.5-0.5v-0.9431l0.8164,0.4714
      c0.0791,0.0454,0.165,0.0669,0.25,0.0669c0.1719,0,0.3408-0.0894,0.4326-0.25C14.1377,21.0469,14.0557,20.7412,13.8164,20.603z"/>
  </g>
</template>

<script>
export default {
  name: 'SnowLight'
}
</script>